import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.JobMatching;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "JobMatching.Phaser.IntroductionScene.1",
            "JobMatching.Phaser.IntroductionScene.2",
            "JobMatching.Phaser.IntroductionScene.3",
            "JobMatching.Phaser.IntroductionScene.4",
            "JobMatching.Phaser.IntroductionScene.5",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/JobMatchingGame/scenes/GameIntro.ts